import React, {useState} from 'react';
import './Only2Product.css'
// import { name } from 'tar/lib/types';
import {Link, NavLink, useNavigate} from "react-router-dom";
import { motion } from 'framer-motion'; // Import Framer Motion

export default function Only2Product(props) {
  const { id, name, title, imageUrl, price, discountPrice, addToCart, quantity } = props;
  const [hovered, setHovered] = useState(false);

  const isInStock = quantity > 0;
  const handleAddToCartClick = () => {
    if (!isInStock) {
      alert("This Product is OUT OF STOCK. So you cannot BUY this product. Thanks.");
    } else {
      addToCart({ id, imageUrl, name, title, price, discountPrice });
    }
  };

  const navigate = useNavigate();
    const handleProductClick = (Id) => {
      navigate(`/product_detail/${Id}`); // Navigate to the product detail page with the specific product ID
    };
    console.log("imageURL:",imageUrl);

  return (
    <>
      <motion.div 
      onClick={() => handleProductClick(id)}
      className="double-card-container"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      whileHover={{ scale: 1.05 }} // Scale up on hover
      whileTap={{ scale: 0.95 }} // Scale down on tap
      initial={{ opacity: 0, y: 20 }} // Initial animation state
      animate={{ opacity: 1, y: 0 }} // Animate to visible state
      transition={{ duration: 0.3 }} // Animation duration
      >
        {/* <NavLink to={`/product_detail/${id}`} className='double-card-product-Detail-Link'> */}
          <img 
            // src={imageUrl[0]} 
            src={hovered ? imageUrl[1] : imageUrl[0]} 
            alt="product image" 
            className="double-card-image" 
          />
          
          <h2 className="double-card-name">{title}</h2>
          {/* <h2 className="double-card-name">{name}</h2> */}
          {/* </NavLink> */}
          {/* <p className="double-card-price">Rs.{price}</p> */}
          <div>
            {discountPrice && discountPrice > 0 ? (
              <>
                <p className="double-card-price">
                  Rs. {price}
                </p>
                <p className="double-card-discount-price">
                  Rs. {discountPrice}
                </p>
              </>
            ) : (
                  <p className="double-card-discount-price">Rs.{price}</p>
                )}
          </div>
        
        {/* <p>{props.description}</p> */}
        <motion.button className='double-card-shop-now-button' 
                onClick={ (e) =>{
                  e.stopPropagation();
                  handleAddToCartClick();
                  navigate(`/shopnow`);
                }}
                whileHover={{ scale: 1.04 }} // Scale button on hover
               whileTap={{ scale: 0.9 }} // Scale button on tap
        >
          Shop Now
        </motion.button>
        {/* <p>
        {isInStock ? (
          <Link to="/shopnow">
            <button className='double-card-shop-now-button' onClick={handleAddToCartClick}>Shop Now</button>
          </Link>
        ) : (
          <button className='double-card-shop-now-button' onClick={handleAddToCartClick}>Shop Now</button>
        )}
        </p> */}
      </motion.div>
    </>
  );
}
